module.exports = __webpack_public_path__ + "media/fonts/BrandonGrotesque-Medium-4b55f0015bb1802a5d81b749f315d2bf.woff";